module.exports = __webpack_public_path__ + "static/media/circle-status-agreed.63e29cce.svg";